import { data } from '../../svg/FormatItalic/data';
import { makeIcon } from '../makeIcon';

export const FormatItalic = makeIcon(data, 'format_italic', 'FormatItalic');

export default FormatItalic;
